/**
 * General — the home project. Every conversation starts in it, and anything
 * saved without a project belongs to it: everyday talk, notes and knowledge
 * about anything. Work that grows into its own thing moves to a project of
 * its own.
 *
 * It is built in on every surface: the project store reports it as existing
 * whether or not it has been written to (`storage/projectStore.ts`), it can't
 * be created, deleted or renamed, and its description is fixed here.
 */
export const GENERAL_PROJECT = 'general';

/** General's description — fixed; the project map shows it like any other. */
export const GENERAL_DESCRIPTION =
  'Home space for everyday conversations not tied to a project — notes, ideas and knowledge about anything; work that grows into a project moves to its own.';

/** How a project is named to people: General by its name, every other project by its slug. */
export function projectDisplayName(slug: string): string {
  return slug === GENERAL_PROJECT ? 'General' : slug;
}

/** Projects in display order: General first, then the rest as given. */
export function generalFirst(slugs: readonly string[]): string[] {
  return [GENERAL_PROJECT, ...slugs.filter((s) => s !== GENERAL_PROJECT)];
}
